var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "tenantId",
                    label: "学校",
                  },
                },
                [
                  _c("school-search-select", {
                    attrs: { list: _vm.tenantList, disabled: _vm.editMode },
                    model: {
                      value: _vm.model.tenantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "tenantId", $$v)
                      },
                      expression: "model.tenantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "days",
                    label: "试用天数",
                  },
                },
                [
                  _c("a-input-number", {
                    attrs: { placeholder: "请输入天数" },
                    model: {
                      value: _vm.model.days,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "days", $$v)
                      },
                      expression: "model.days",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "trialOpenFlag",
                    label: "会员权限是否开启",
                  },
                },
                [
                  _c("a-switch", {
                    attrs: { checked: _vm.model.trialOpenFlag == 1 },
                    on: { change: _vm.changeOpen },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }